/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInbox(inboxId, params = {}) {
    return axios.delete(`${this.url}/${inboxId}`, { params });
  }

  migrateInboxData(inboxId, targetInboxId) {
    return axios.post(`${this.url}/${inboxId}/migrate_data`, {
      target_inbox_id: targetInboxId,
    });
  }

  syncWhatsAppProfileAvatar(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_profile_avatar`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getMessageTemplates(inboxId, params = {}, config = {}) {
    return axios.get(`${this.url}/${inboxId}/message_templates`, {
      ...config,
      params,
    });
  }

  updateWhatsappBusinessManagementToken(inboxId, businessManagementToken) {
    return axios.put(
      `${this.url}/${inboxId}/whatsapp_business_management_token`,
      {
        business_management_token: businessManagementToken,
      }
    );
  }

  uploadWhatsappTemplateMedia(inboxId, file, headerFormat) {
    const data = new FormData();
    data.append('file', file);
    data.append('header_format', headerFormat);
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_message_templates/upload_media`,
      data
    );
  }

  generateWhatsappTemplate(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_message_templates/generate`,
      params
    );
  }

  createWhatsappTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_message_templates`, {
      template,
    });
  }

  updateWhatsappTemplate(inboxId, templateId, template) {
    return axios.patch(
      `${this.url}/${inboxId}/whatsapp_message_templates/${templateId}`,
      { template }
    );
  }

  deleteWhatsappTemplate(inboxId, templateId) {
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_message_templates/${templateId}`
    );
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }
}

export default new Inboxes();
